var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Checkbox } from '@folio/stripes/components';
import React from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { AggregateCriteriaCard } from '../Criteria';
export default function AggregateSection() {
    var isAggregateEnabled = useField('aggregate', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    var intl = useIntl();
    return (React.createElement("div", null,
        React.createElement(Field, { name: "aggregate", type: "checkbox", defaultValue: false }, function (fieldProps) { return (React.createElement(Checkbox, __assign({}, fieldProps, { fullWidth: true, label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.aggregate.enabler',
            }) }))); }),
        React.createElement("p", null,
            React.createElement("i", null,
                React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.description" }))),
        isAggregateEnabled && React.createElement(AggregateCriteriaCard, null)));
}
